const isValidCallback = (_: any) => {
    return {
        isValid: true,
        error: "",
    };
};

export default isValidCallback;
